// ** Icons Import
import { Heart } from 'react-feather';

const Footer = () => {
  return (
    <p className="clearfix mb-0">
      <span className="float-md-right d-none d-md-block">
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <a href="https://bluesmiles.com.br" target="_blank">
          BlueSmiles
        </a>
        {/* <span className="d-none d-sm-inline-block">, All rights Reserved</span> */}
      </span>
    </p>
  );
};

export default Footer;
